import { ArrowLeft01Icon, ArrowRight01Icon, SquareLock01Icon } from '@hugeicons/react'
import _ from 'lodash'
import { DateTime } from 'luxon'

import { useRecord } from '@/shared/hooks'
import { useQuizzesProgresses } from '@/shared/hooks/useQuizzesProgresses'
import { LevelPlayInterstitial } from '@/shared/level-play'
import { Button } from '@/shared/ui/Button'

import { useQuizContext } from '../../context'

/**
 * Quiz bloqueado, a partir do `lockReason` do progresso.
 *
 * Convive com o gate de `Show/Play/index.jsx`, que verifica `_blockCondition` na
 * entrada. As duas fontes são diferentes — `isLocked` vem do store de quizzes,
 * `_blockCondition` vem do registro — e por isso esta tela **não** foi
 * substituída pelo `Blocker`: trocar sem antes provar a equivalência poderia
 * liberar um quiz que deveria estar bloqueado.
 */
const lockMessage = ({ lockReason, quiz }) => {
  if (lockReason === 'previousQuiz')
    return 'Este quiz está bloqueado até a conclusão do quiz anterior.'

  if (lockReason === 'mission') {
    const mission = _.get(quiz, 'unlock_mission.name')

    return `Este quiz está bloqueado até a conclusão da missão ${mission}.`
  }

  if (lockReason === 'time') {
    const quando = DateTime.fromISO(quiz?.locked_until).toLocaleString(
      DateTime.DATETIME_MED
    )

    return `Este quiz está bloqueado até ${quando}.`
  }

  return 'Este quiz está bloqueado.'
}

export const DigitalProductQuizQuizBlocked = () => {
  const {
    quiz,
    config: { apiBasePath, basePath }
  } = useQuizContext()
  const { lockReason } = useQuizzesProgresses({ id: quiz?.id })

  const { record: nextQuiz } = useRecord({
    r: apiBasePath,
    id: quiz?.uid,
    action: 'next'
  })

  return (
    <LevelPlayInterstitial
      icon={<SquareLock01Icon size={48} variant="duotone" className="text-danger" />}
      title="Bloqueado"
      description={lockMessage({ lockReason, quiz })}
      action={
        <div className="flex flex-col md:flex-row gap-4 justify-around w-full">
          <Button
            href={basePath}
            variant="ghost"
            className="grow"
            leadingIcon={<ArrowLeft01Icon size={18} />}
            showTrailingIcon={false}
          >
            Voltar para os quizzes
          </Button>
          {nextQuiz && (
            // A rota do quiz é `/quizzes/:uid/iniciar`. A versão anterior
            // montava `${basePath}/niveis/${uid}/iniciar` — herança do
            // copy-paste da jornada, que gerava `/quizzes/niveis/...`, uma rota
            // que não existe.
            <Button
              href={`${basePath}/${nextQuiz.uid}/iniciar`}
              variant="primary"
              className="grow"
              trailingIcon={<ArrowRight01Icon size={18} />}
            >
              Próximo quiz
            </Button>
          )}
        </div>
      }
    />
  )
}
